import type { Trade } from 'lib/sdks/search';
import type { ReactNode, Dispatch, SetStateAction } from 'react';
import { createContext, useContext, useState } from 'react';

type TradeContextValue = [Trade | null, Dispatch<SetStateAction<Trade | null>>];

export const TradeContext = createContext<TradeContextValue | null>(null);

export const TradeProvider = ({
  children,
  initialValue,
}: {
  children: ReactNode;
  initialValue: Trade | null;
}) => {
  const [trade, setTrade] = useState(initialValue);
  return (
    <TradeContext.Provider value={[trade, setTrade]}>
      {children}
    </TradeContext.Provider>
  );
};

export const useTradeContext = () => {
  const tradeContext = useContext(TradeContext);

  if (!tradeContext) {
    throw new Error(
      'useTradeProfileContext has to be used within <TradeProfileProvider>',
    );
  }

  return tradeContext;
};
